import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GetCancellationToken } from "../../utility/HttpServiceUtility";
import { ReleaseNote } from "../../apiModels/Versioning/ReleaseNote";
import { useDispatchAlert } from "../UI/Alert";
import { useReleaseNotesService } from "../../api/ServiceContext";


export function useReleaseNotesHook(
    { 
        page = 1,
        pageSize = 10,
    } :
    { 
        page?: number;
        pageSize?: number;
    }) {
    
    const cancellationToken = GetCancellationToken();
    const releaseNotesService = useReleaseNotesService(cancellationToken);
    const dispatchAlert = useDispatchAlert();
    const { t } = useTranslation();

    const [releaseNotes, setReleaseNotes] = useState<ReleaseNote[] | null>(null);
    const [awaitingResponse, setAwaitingResponse] = useState(true);
    
    useEffect(() => {         
        setAwaitingResponse(true);
        
        releaseNotesService.getReleaseNotes(page, pageSize)
            .then(response => {
                setReleaseNotes(response);
                setAwaitingResponse(false);
            })
            .catch((error_) => {
                if (!error_.isCancelled) {
                    dispatchAlert({
                        message: t("generic.errorMessage"),
                        messageType: "error",
                    });
                }
        });
            
        return () => {
            cancellationToken.cancel();
        };
    }, [page, pageSize]);

    return {
        releaseNotes: releaseNotes,
        awaitingResponse: awaitingResponse,
    };
}